import { useEffect, useState } from "react";

export function useIsPlayerReady(
  playerRef: React.RefObject<HTMLElement | null>,
): boolean {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkReady = () => {
      const el = playerRef.current;
      if (!el) return false;
      return (
        el.classList.contains("bwp") && getComputedStyle(el).display !== "none"
      );
    };

    const interval = setInterval(() => {
      if (checkReady()) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [playerRef]);

  return isReady;
}
